export default __webpack_public_path__ + "static/media/hw-driver.68b6aa46.jpg";